<div class="card mb-3 pointer" (click)="openPartySignupDetailsPage($event)" >
    <div class="row">
      <div class="col col-3">
          <img
          [src]="img"
          alt="PartySignup Campaign Image"
          class="img-fluid rounded-start"
          style="height: 110px; width: 220px; border-radius: 4px;"
          />
      </div>
      <div class="col-9 d-flex justify-content-between">
        <div class="d-flex flex-column justify-content-between">
          <div class="d-flex align-items-center justify-content-start">
            <div class="d-flex align-items-center">
              <h5 class="subtitle-1 mb-0">{{selectedPartySignup.name}}</h5>
              <i class="fas fa-chevron-right ml-2 pointer"></i>
            </div>
          </div>
          <div class="d-flex">
            <div class="d-flex flex-column justify-content-center">
              <span
                class="caption custom-badge"
                [ngClass]="{
                  'badge-success': statusType === 'Active',
                  'badge-warning': statusType === 'Hidden' || statusType === 'Not started',
                  'custom-badge-secondary': statusType === 'Ended' || statusType === 'Deactivated'
                }"
              >
              {{ statusType }}
              </span>
            </div>
            
            @if(typeData.partySignupStats){
              <div class="ml-4 d-flex">
                <div class="body-2 mr-4 align-content-center">
                  {{typeData.partySignupStats?.totalQuantity}} spots sold 
                </div>
                <div class="body-2 align-content-center">
                  {{typeData.partySignupStats?.checkedInQuantity}} checked in
                </div>
              </div>
              } 
  
          </div>
        </div>
        
        <div class="d-flex justify-content-between action-row">
          <div class="d-flex flex-column justify-content-end">
            <ul class="d-flex flex-row justify-content-end  list-group" style="height: 36px;" >
                <li class="list-group-item  d-flex p-0 cursor--pointer noDetaisClick">
                <app-party-signup-popover class="noDetaisClick" [campaignId]="selectedPartySignup.id">
                    <span class="noDetaisClick ml-1 pointer body-1">Download Bid Sheets</span>
                </app-party-signup-popover>
                </li>

                <li class=" display-flex ml-2 pointer noDetaisClick">
                  <app-party-signup-tabs-popover [signupCampaign]="selectedPartySignup"></app-party-signup-tabs-popover>
                </li>
            </ul> 
          </div>
        </div>
      </div>
    </div>
  </div>
  